import React from 'react';
import Facts_list from './facts_list/index';
import Main_Widget from './main_widget';

const AdminDashboard = () => {
    return ( 
        <div>
            <Main_Widget />
            
        </div>
     );
}
 
export default AdminDashboard;